import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/OffboardsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { DatePicker, MyReactSelect, TextArea, InputFile, MySelect } from '../../inputs/inputs';
import { getData as getClients } from '../../../models/ClientsModel';
import { getData as getRequirements } from '../../../models/RequirementsModel';
import { getData as getCandidates } from '../../../models/OnboardsModel';
import { getData as getLeavingReasons } from '../../../models/LeavingReasonModel';
import AdminLayout from '../../layout/AdminLayout';
import { Helmet } from 'react-helmet';
import PageHeader from '../../common/PageHeader';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';
import { QuickAdd } from '../../modals/QuickAdd';
import { checkPermission } from "../../../helpers/GeneralHelper";

export const OffboardForm = () => {

  const location = useLocation();
  const isEdit = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'edit';
  const isView = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'view';
  const module = location.state?.module;
  const data = location.state?.data;

  const inputFields = {
    'offboard_onboard_id': '',
    'offboard_leaving_reason_id': '',
    'offboard_comments': '',
    'offboard_file_id': '',
    'offboard_last_day': '',
  }

  const formatOptions = [
    {
      type: 'react-select',
      column: 'offboard_onboard_id',
      labelColumn: 'candidate_name'
    },
    {
      type: 'react-datepicker',
      column: 'offboard_last_day',
    },
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({ clients: false });

  const optionsYesNo = [
    {value: 1, label: 'Yes' },
    {value: 0, label: 'No' },
  ];

  const optionsTax = [
    {value: 'Inclusive', label: 'Inclusive' },
    {value: 'Exclusive', label: 'Exclusive' },
  ];

  //const [clients, setClients] = useState([]);
  //const [requirements, setRequirements] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [leavingReasons, setLeavingReasons] = useState([]);

//   useEffect(() => {
//     const fetchClients = async () => {
//       if (! fields.onboard_candidate_id) {
//         fields.onboard_client_id = '';
//         setRequirements([]);
//         return;
//       }
//       var candidate_id = '';
//       if(fields.onboard_candidate_id){
//         candidate_id = fields.onboard_candidate_id.value;
//       }
//       try {
//         const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1, candidate_id: candidate_id});
//         if (! result) return;

//         const clientOptions = result.clients.map(client => ({
//           value: client._client_id,
//           label: client.client_name
//         }));

//         setClients(clientOptions);
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     fetchClients();
//   }, [fields.onboard_candidate_id]);

//   const [loadingRequirements, setLoadingRequirements] = useState(false);
//   useEffect(() => {
//     const fetchRequirements = async() => {
//       if (! fields.onboard_client_id) {
//         fields.onboard_requirement_id = '';
//         setRequirements([]);
//         return;
//       }

//       var requirement_client_id = '';
//       if (fields.onboard_client_id) {
//         requirement_client_id = fields.onboard_client_id.value;
//       }
//       var candidate_id = '';
//       if(fields.onboard_candidate_id){
//         candidate_id = fields.onboard_candidate_id.value;
//       }

//       setLoadingRequirements(true);

//       try {
//         let apiParam = {user_token: user_data.user_token, 'requirement_client_id': requirement_client_id, page: 1, limit: -1, candidate_id: candidate_id};
//         const response = await getRequirements(apiParam);

//         if (typeof response != typeof undefined) {
//           let options = [];
//           let flag = false;
//           response.requirements.forEach(function(item) {
//             if (fields.onboard_requirement_id == item._requirement_id || fields.onboard_requirement_id?.value == item._requirement_id) {
//               flag = true;
//             }
//             options.push({
//               value: item._requirement_id,
//               label: item.requirement_name
//             });
//           });

//           if (! flag) {
//             fields.onboard_requirement_id = '';
//           }

//           setRequirements(options);
//         }
//       } catch (error) {
//         console.error(error);
//       }

//       setLoadingRequirements(false);
//     }

//     fetchRequirements();
//   }, [fields.onboard_client_id, fields.onboard_candidate_id]);
  
  const [loadingCandidates, setLoadingCandidates] = useState(false);
  useEffect(() => {
    const fetchCandidates = async() => {
      // if (! fields.onboard_requirement_id) {
      //   fields.onboard_candidate_id = '';
      //   setCandidates([]);
      //   return;
      // }

      setLoadingCandidates(true);

      try {
        let apiParam = {user_token: user_data.user_token, page: 1, limit: -1, onboard_is_offboard:0};
        const response = await getCandidates(apiParam);

        if (typeof response != typeof undefined) {
          let options = [];
          let flag = false;
          response.onboards.forEach(function(item) {
            if (fields.offboard_onboard_id == item._onboard_id || fields.offboard_onboard_id?.value == item._onboard_id) {
              flag = true;
            }
            if(item.onboard_is_offboard==0){
                options.push({
                    value: item._onboard_id,
                    label: item.candidate_name+' ('+item.client_name+')'
                });
            }
            
          });

          if (! flag) {
            fields.offboard_onboard_id = '';
          }

          setCandidates(options);
        }
      } catch (error) {
        console.error(error);
      }

      setLoadingCandidates(false);
    }

    const fetchLeavingReasons = async() => {
      try {
        let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
        const response = await getLeavingReasons(apiParam);

        if (typeof response != typeof undefined) {
          let options = [];
          response.leaving_reasons.forEach(function(item) {
            options.push({
              value: item._reason_id,
              label: item.reason_name
            });
          });

          setLeavingReasons(options);
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchCandidates();
    fetchLeavingReasons();
  }, []); //fields.onboard_requirement_id

  useEffect(() => {
    if (data) {
      setId(data[module.primaryCol]);
      setFields(formatDataBeforeDisplay(data, formatOptions));
      setErrors({});
    }

    // const fetchSelectedSkills = async() => {
    //   if (! data?._onboard_id) {
    //     return;
    //   }

    //   try {
    //     const response = await model.getSelectedSkills(user_data.user_token, data._onboard_id);

    //     if (typeof response != typeof undefined) {
    //       let skills = [];
    //       response.data.skills.forEach(function(item) {
    //         skills.push({ value: item._skill_id, label: item.skill_name });
    //       });

    //       setFields((prev) => ({ ...prev, 'onboard_skills': skills }));
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };

    // fetchSelectedSkills();
  }, [data]);

  const validator = useRef(new SimpleReactValidator(validorSettings()));
  const submit = async(e) => {
    e.preventDefault();

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);

      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        model.saveToStorage(response.data[module.key], response.data.pagination);
        navigate('/' + module.route);
        // if (isEdit) {
        //   navigate('/' + module.route);
        // } else {
        //   setFields(inputFields);
        // }
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data?.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  if (! module) {
    navigate('/offboards');
    return;
  }

return (
<AdminLayout>
<Helmet>
    <title>{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle} - Digital CMS</title>
</Helmet>

<div className="main-content app-content">
<div className="container-fluid cms-form-shell">
<PageHeader module={module} />

<form onSubmit={submit}>
    <div className="row">
        <div className="col-sm-9">
            <div className="card custom-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div className="card-title">{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle}</div>
                </div>
                <div className="card-body">
                    <div className="row gy-2">
                        <div className="col-xl-4 mb-3">
                          <MyReactSelect column="offboard_onboard_id" label="Candidate" options={candidates} required={true} fields={fields} setFields={setFields} errors={errors} disabled={ !isView ? isEdit : isView} />
                        </div>

                        <div className="col-xl-4 mb-3">
                          <DatePicker column="offboard_last_day" label="Last Day of Work" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>

                        <div className="col-xl-4 mb-3">
                          <InputFile column="offboard_file_id" label="Document" required={false} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                          <small>Formats: PDF & DOCX</small>
                        </div>

                        <div className="col-xl-6 mb-3">
                          {/* <TextArea column="offboard_leaving_reason_id" label="Leaving Reason" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} /> */}
                          <MySelect column="offboard_leaving_reason_id" label="Leaving Reason" options={leavingReasons} required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>

                        <div className="col-xl-6 mb-3">
                          <TextArea column="offboard_comments" label="Comments" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-sm-3">
            <div className="card custom-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                    { (isView && checkPermission(module.route, 'edit')) ? 
                    <a  className="btn btn-icon btn-sm btn-info"
                        title="Edit"
                        onClick={() => navigate(`/offboards/${data.offboard_unique_id}/edit`,{
                            state: {
                                data: data,
                                module: module,
                            },
                        })} // Navigate to the edit page
                    >
                        <i className='bx bxs-edit'></i>
                    </a> :
                    <div>
                        <button className="btn btn-primary btn-md" disabled={loading}>
                          {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Save'}
                        </button>
                    </div>}
                    <div className="d-flex flex-wrap gap-2">
                        <Link className="btn btn-light btn-sm float-end" to="/onboards">
                          <i className="bi bi-reply me-1 fw-semibold"></i> Back
                        </Link>
                    </div>
                </div>
                <div className="card-body"></div>
            </div>
        </div>
    </div>
</form>   
</div>
</div>
{/* <QuickAdd title="Client" modalKey="clients" column="onboard_client_id" setFieldOptions={setClients} showModal={quickModals.clients} form={quickAddClient} setShowModal={setQuickModals} fields={fields} setFields={setFields} /> */}
<Helmet></Helmet>
</AdminLayout>
)};